import NotificationCenter from './NotificationCenter';

export default NotificationCenter;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/notification/index.js
// module id = 411
// module chunks = 0